document.addEventListener("DOMContentLoaded", function () {
  let isUpdatingCart = false;
  let isCustomCartHandlerActive = false;

  // Global function to open the cart drawer
  window.openCartDrawer = function () {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
    }
  };

  // Define quantity-selector custom element
  if (!customElements.get("quantity-selector")) {
    customElements.define(
      "quantity-selector",
      class QuantitySelector extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector("[data-quantity-input]");
          this.minusButton = this.querySelector("[data-quantity-minus]");
          this.plusButton = this.querySelector("[data-quantity-plus]");
          this.minusWrapper = this.querySelector("[data-button-wrapper-minus]");
          this.plusWrapper = this.querySelector("[data-button-wrapper-plus]");

          // Prevent multiple event listeners
          if (
            this.minusButton &&
            !this.minusButton.hasAttribute("data-quantity-handled")
          ) {
            this.minusButton.setAttribute("data-quantity-handled", "true");
            this.minusButton.addEventListener("click", (event) =>
              this.decreaseQuantity(event)
            );
          }

          if (
            this.plusButton &&
            !this.plusButton.hasAttribute("data-quantity-handled")
          ) {
            this.plusButton.setAttribute("data-quantity-handled", "true");
            this.plusButton.addEventListener("click", (event) =>
              this.increaseQuantity(event)
            );
          }

          if (this.input) {
            this.input.addEventListener(
              "change",
              this.updateButtonStates.bind(this)
            );
            this.updateButtonStates();
          }
        }

        decreaseQuantity(event) {
          // Stop the event from being handled by other listeners
          if (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
          }

          if (this.input) {
            const currentValue = parseInt(this.input.value) || 1;
            const minValue = parseInt(this.input.min) || 1;
            const incrementValue =
              parseInt(this.input.getAttribute("data-increment-value")) || 1;
            const newValue = Math.max(minValue, currentValue - incrementValue);
            this.input.value = newValue;
            this.input.dispatchEvent(new Event("change", { bubbles: true }));
            this.updateButtonStates();
          }
        }

        increaseQuantity(event) {
          if (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
          }

          if (this.input) {
            const currentValue = parseInt(this.input.value) || 1;
            const maxValue = parseInt(this.input.max) || 999;
            const incrementValue =
              parseInt(this.input.getAttribute("data-increment-value")) || 1;
            const newValue = Math.min(maxValue, currentValue + incrementValue);
            this.input.value = newValue;
            this.input.dispatchEvent(new Event("change", { bubbles: true }));
            this.updateButtonStates();
          }
        }

        updateButtonStates() {
          if (!this.input) return;

          const currentValue = parseInt(this.input.value) || 1;
          const minValue = parseInt(this.input.min) || 1;
          const maxValue = parseInt(this.input.max) || 999;

          // Update minus button state
          if (this.minusWrapper) {
            if (currentValue <= minValue) {
              this.minusWrapper.classList.add(
                "quantity-selector__button-wrapper--disabled"
              );
            } else {
              this.minusWrapper.classList.remove(
                "quantity-selector__button-wrapper--disabled"
              );
            }
          }

          // Update plus button state
          if (this.plusWrapper) {
            if (currentValue >= maxValue) {
              this.plusWrapper.classList.add(
                "quantity-selector__button-wrapper--disabled"
              );
            } else {
              this.plusWrapper.classList.remove(
                "quantity-selector__button-wrapper--disabled"
              );
            }
          }
        }
      }
    );
  }

  async function addProductToCart(
    variantId,
    quantity = 1,
    buttonElement = null,
    sellingPlan = null
  ) {
    isCustomCartHandlerActive = true;

    const itemsToAdd = [{ id: variantId, quantity: quantity }];

    if (sellingPlan) {
      itemsToAdd[0].selling_plan = sellingPlan;
    }

    // Check if this is a heat sensitive product and add ice pack if needed
    let isHeatSensitive = false;

    if (
      buttonElement &&
      buttonElement.getAttribute("data-heat-sensitive") === "true"
    ) {
      isHeatSensitive = true;
    } else {
      try {
        // Get variant info first to find the product handle
        const variantResponse = await fetch(`/variants/${variantId}.js`);
        if (variantResponse.ok) {
          const variantData = await variantResponse.json();
          const productHandle = variantData.product_handle;

          // Get product info to check if it's heat sensitive
          const productResponse = await fetch(`/products/${productHandle}.js`);
          if (productResponse.ok) {
            const productData = await productResponse.json();
            if (
              productData.tags &&
              productData.tags.includes("Heat Sensitive")
            ) {
              isHeatSensitive = true;
            }
          }
        }
      } catch (error) {
        console.error("Error checking heat sensitive product:", error);
      }
    }

    if (isHeatSensitive) {
      // Add heat sensitive property to the item
      itemsToAdd[0].properties = { Heat_Sensitive: "true" };

      try {
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        const alreadyHasIcePack = cartData.items.some(
          (item) => item.id === 29360514498632
        );

        if (!alreadyHasIcePack) {
          itemsToAdd.push({ id: 29360514498632, quantity: 1 });
        }
      } catch (error) {
        console.error("Error checking cart for ice pack:", error);
      }
    }

    const body = JSON.stringify({
      items: itemsToAdd,
      sections: ["cart-drawer", "header-cart-icons"],
      sections_url: window.location.pathname,
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: body,
    })
      .then((response) => response.json())
      .then((data) => {
        if (
          !data.status &&
          (data.item_count > 0 || (data.items && data.items.length > 0))
        ) {
          if (!data.item_count && data.items) {
            data.item_count = data.items.length;
          }
          updateCartAfterAdd(data);
        }
      })
      .catch((err) => {
        console.error("Cart add error:", err);
      })
      .finally(() => {
        isCustomCartHandlerActive = false;
      });
  }

  // Add a capture phase listener to intercept all cart-related button clicks
  document.addEventListener(
    "click",
    async function (event) {
      const quickBuyButton = event.target.closest("[data-quick-buy]");
      const productAtcButton = event.target.closest("[data-product-atc]");

      // Check if this is a cart-related button click
      if (quickBuyButton || productAtcButton) {
        // If our custom handler is already active, prevent other handlers
        if (isCustomCartHandlerActive) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return false;
        }

        // Handle quick-buy buttons
        if (quickBuyButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const form = quickBuyButton.closest("form");
          const variantId =
            form?.querySelector('select[name="id"], input[name="id"]')?.value ||
            quickBuyButton.getAttribute("data-variant-id");
          const quantity =
            parseInt(form?.querySelector('input[name="quantity"]')?.value) || 1;
          const sellingPlan =
            form?.querySelector('input[name="selling_plan"]')?.value || null;

          if (variantId && variantId !== "not-selected") {
            await addProductToCart(
              variantId,
              quantity,
              quickBuyButton,
              sellingPlan
            );
          }
          return false;
        }

        // Handle product ATC buttons
        if (productAtcButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const form = productAtcButton.closest("form");
          const variantId =
            form?.querySelector('select[name="id"], input[name="id"]')?.value ||
            productAtcButton.getAttribute("data-variant-id");
          const quantity =
            parseInt(form?.querySelector('input[name="quantity"]')?.value) || 1;
          const sellingPlan =
            form?.querySelector('input[name="selling_plan"]')?.value || null;

          if (variantId && variantId !== "not-selected") {
            await addProductToCart(
              variantId,
              quantity,
              productAtcButton,
              sellingPlan
            );
          }
          return false;
        }
      }
    },
    true
  );

  // Quantity selector buttons are now handled by their respective custom elements

  // Listen for cart quantity changes in cart drawer
  document.addEventListener("change", function (event) {
    const cartQuantitySelectors = [
      "[data-cart-quantity]",
      ".cart-item__quantity input",
      ".quantity__input",
      "input[name='updates[]']",
    ];

    let quantityInput = null;
    for (const selector of cartQuantitySelectors) {
      quantityInput = event.target.closest(selector);
      if (quantityInput) {
        // Update immediately
        fetchCurrentCartAndUpdate();
        break;
      }
    }
  });

  // Listen for cart updates
  document.addEventListener("click", function (event) {
    const removeButton = event.target.closest("[data-cartitem-remove]");
    if (removeButton) {
      // Update immediately
      fetchCurrentCartAndUpdate();
    }
  });

  // Listen for the cartcount
  window.addEventListener("cartcount:update", function (event) {
    if (event.detail && event.detail.item_count !== undefined) {
      updateCartCountElements(event.detail.item_count);
    }
  });

  const originalFetch = window.fetch;
  window.fetch = function (url, options) {
    if (
      url &&
      (url.includes("/cart/add.js") ||
        url.includes("/cart/update.js") ||
        url.includes("/cart/change.js") ||
        url.includes("/cart/change")) &&
      options &&
      options.method === "POST"
    ) {
      return originalFetch.apply(this, arguments).then((response) => {
        const clonedResponse = response.clone();

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          clonedResponse
            .json()
            .then((data) => {
              if (!data.status) {
                if (!isUpdatingCart) {
                  isUpdatingCart = true;

                  // Calculate total items from the response
                  let totalItems = 0;
                  if (data.items && Array.isArray(data.items)) {
                    totalItems = data.items.reduce(
                      (sum, item) => sum + item.quantity,
                      0
                    );
                  } else if (data.item_count) {
                    totalItems = data.item_count;
                  }

                  updateCartCountElements(totalItems);

                  // Dispatch the cartcount:update event
                  window.dispatchEvent(
                    new CustomEvent("cartcount:update", {
                      detail: { ...data, item_count: totalItems },
                    })
                  );

                  // Only update cart drawer content for add operations
                  if (url.includes("/cart/add.js")) {
                    updateCartDrawerContent(data).then(() => {
                      window.openCartDrawer();
                    });
                  }

                  isUpdatingCart = false;
                }
              }
            })
            .catch((err) => {
              console.error("Error parsing cart JSON response:", err);
            });
        } else {
          if (!isUpdatingCart) {
            isUpdatingCart = true;
            fetchCurrentCartAndUpdate();
            isUpdatingCart = false;
          }
        }

        return response;
      });
    }

    return originalFetch.apply(this, arguments);
  };

  function updateCartAfterAdd(cartData) {
    updateCartDrawerContent().then(() => {
      window.openCartDrawer();
    });

    fetchCurrentCartAndUpdate();

    if (typeof publish === "function") {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "quick-buy-cart-updater",
        cartData: cartData,
      });
    }
  }

  function fetchCurrentCartAndUpdate() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const totalItems = cart.item_count || 0;
        updateCartCountElements(totalItems);

        // Dispatch the cartcount:update event with correct total
        window.dispatchEvent(
          new CustomEvent("cartcount:update", {
            detail: { ...cart, item_count: totalItems },
          })
        );
      })
      .catch((err) => {
        console.error("Error fetching current cart:", err);
      });
  }

  function updateCartCountElements(totalItems) {
    const cartCountSelectors = [
      "[data-header-cart-count]",
      ".site-header-cart--count",
      "[data-cart-count]",
    ];

    let cartCountElements = [];
    for (const selector of cartCountSelectors) {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        cartCountElements = elements;
        break;
      }
    }

    cartCountElements.forEach((element) => {
      if (totalItems > 0) {
        element.setAttribute("data-header-cart-count", totalItems);
        element.classList.add("visible");
      } else {
        element.removeAttribute("data-header-cart-count");
        element.classList.remove("visible");
      }
    });
  }

  function updateCartDrawerContent(cartData = null) {
    return fetch(`${window.location.pathname}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const newDrawerInner = html.querySelector(".drawer__inner");
        const existingDrawerInner = document.querySelector(".drawer__inner");

        if (newDrawerInner && existingDrawerInner) {
          existingDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }

        const newCartDrawer = html.querySelector("cart-drawer");
        const existingCartDrawer = document.querySelector("cart-drawer");
        if (newCartDrawer && existingCartDrawer) {
          const isEmpty = newCartDrawer.classList.contains("is-empty");
          existingCartDrawer.classList.toggle("is-empty", isEmpty);
        }

        //  update cart count
        // if (cartData) {
        //   // Calculate total items from the provided cartData
        //   let totalItems = 0;
        //   if (cartData.items && Array.isArray(cartData.items)) {
        //     totalItems = cartData.items.reduce(
        //       (sum, item) => sum + item.quantity,
        //       0
        //     );
        //   } else if (cartData.item_count) {
        //     totalItems = cartData.item_count;
        //   }

        //   updateCartCountElements(totalItems);

        //   // Dispatch the cartcount:update event
        //   window.dispatchEvent(
        //     new CustomEvent("cartcount:update", {
        //       detail: { ...cartData, item_count: totalItems },
        //     })
        //   );
        // } else {
        //   fetchCurrentCartAndUpdate();
        // }
      })
      .catch((e) => {
        console.error("Cart drawer update error:", e);
      });
  }

  // Global function to refresh cart drawer content
  window.updateCartDrawerContent = updateCartDrawerContent;
});
